import { useContext, useEffect, useState } from 'react';
import { GetResumen } from '../../data/Help';
import { DataContext } from '../../data/DataContext';
import { Tooltip } from '../controls/Tooltip';
import { Input,DropDown } from '../controls';
import { especialCoverage } from '../../../../utils/constanst';
import Modal from 'react-modal';

const Step3 = () => {

    const { AutoHN, setAutoHN } = useContext(DataContext);
    const [detail, setDetail] = useState([] as Array<IRatesTable>);
    const [resumen, setResumen] = useState({} as IRatesResumen);
    const [propModalSpecial, setpropModalSpecial] = useState(false);
    const [specialteam, setSpecialteam] = useState({} as OA_EquipoEspecial);

    const tool = (
        <Tooltip
        id="idSpecialteam"
        text="Son los accesorios o adiciones que no fueron instalados en su vehículo por el fabricante y deben ser detallados para su cobertura."
        title="Equipo Especial"
        />
    );
  
    useEffect(() => {
        let result = GetResumen(AutoHN);
        setDetail(result.coveragesDetail);
        setResumen(result);
        setAutoHN({ ...AutoHN, summary: result });
        setSpecialteam(AutoHN.OA_EquipoEspecial);
    }, [])

    useEffect(() => {
        setSpecialteam(AutoHN.OA_EquipoEspecial);
    }, [propModalSpecial])

    const onChangeCbo = (property: string, value: string) => {
        setAutoHN({ ...AutoHN, [property]: value });      
    }
    
    const onChangeCob:any = (event:any) => {
        event.preventDefault(); // Evita el comportamiento predeterminado del evento

        // Identificar el objeto con idcob igual a especialCoverage dentro de la propiedad coveragesDetail
        const indexToUpdate = resumen.coveragesDetail.findIndex((coverage) => coverage.idcob === especialCoverage.equipoEspecialHN);
        const indexToUpdate2 =  AutoHN.rates.rates.findIndex((coverage:any) => coverage.idCob === especialCoverage.equipoEspecialHN);

        if (indexToUpdate !== -1) {
            // Actualizar las propiedades sa y value del objeto con idcob
            resumen.coveragesDetail[indexToUpdate].value = `L ${specialteam.Valor}`;
        }

        if (indexToUpdate2 !== -1) {
            // Actualizar las propiedades sa y value del objeto con idcob
            AutoHN.rates.rates[indexToUpdate2].sa = specialteam.Valor;
        }

        // Realiza las validaciones necesarias
        setAutoHN({ ...AutoHN, OA_EquipoEspecial: specialteam });
        setpropModalSpecial(false);
    }

    const changeHandlers:any = (event: any) => {
        setSpecialteam({ ...specialteam, [event.target.name]: event.target.value })
    }

     // Filtra y ordena los datos del proveedor
     const filteredAndSortedData = AutoHN.catPaymentFrequency
     .filter((item: any) => {
       // Convierte AutoHN.vehicleValue a número
        const vehicleValue = Number(AutoHN.vehicleValue);
        
        // Oculta el elemento si item.value es 8 y AutoHN.vehicleValue está en el rango especificado
        if (vehicleValue >= 0 && vehicleValue <= 500000) {
            return item.value !== '8';
        }
        return true;
     })
     .sort((x: any, y: any) => x.value - y.value);
   

    return (
        <>
            <table className='table-autohn-cover mb-10'>
                <thead className='table-autohn-cover-h'>
                    <tr>
                        <th className='w50 text-left-autohn pl-10 pr-10'>
                            <div className='display-flex'>
                                Coberturas
                                <Tooltip id='idCoverage' text='Protección contratada para cubrir el bien ante siniestros' title='Coberturas' />
                            </div>
                        </th>
                        <th className='w20'>Suma Asegurada</th>
                        <th className='w20 hidden'>Prima</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        detail.map((coverage: IRatesTable, index: number) => {
                            return (
                                    <tr key={coverage.idcob}>
                                        <td className='table-autohn-cover-txt1 pt-20 pb-20'>
                                        {coverage.idcob === especialCoverage.equipoEspecialHN? 
                                            <>
                                                <div className='display-flex'>
                                                    {coverage.name} {tool}
                                                </div>
                                                <span className='control-button-special-autohn' onClick={() => setpropModalSpecial(true)}> 
                                                    + Agregar Items 
                                                </span>
                                            </>
                                        : coverage.name
                                        }
                                        </td>
                                        <td className='text-right-autohn pr-10'>{coverage.value}</td>
                                        <td className='text-right-autohn pr-10 hidden'>{coverage.insured}</td>
                                    </tr>
                            );
                        })
                    }
                </tbody>
            </table>
            <div className='lbl-rates-hn'>
                *Aplica a deducible y coaseguro
            </div>
            <table className='table-autohn-detail mt-10'>
                <thead>
                    <tr>
                        <th className='text-left-autohn'>
                            Resumen de prima
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td className='text-left-autohn'>Prima neta</td>
                        <td className='text-right-autohn pr-10'>{resumen.bonusStr}</td>
                    </tr>
                    <tr>
                        <td className='text-left-autohn'>Derecho de emisión</td>
                        <td className='text-right-autohn pr-10'>{resumen.rightEmissionsStr}</td>
                    </tr>
                    <tr>
                        <td className='text-left-autohn'>Impuesto</td>
                        <td className='text-right-autohn pr-10'>{resumen.taxStr}</td>
                    </tr>
                    <tr>
                        <td colSpan={2}>
                            <div className='table-autohn-detail-tot'></div>
                        </td>
                    </tr>
                    <tr >
                        <td className='table-autohn-detail-tot2'>Total</td>
                        <td className='text-right-autohn pr-10 table-autohn-detail-tot2'>{resumen.totalStr}</td>
                    </tr>
                </tbody>
            </table>
            
            <DropDown
                label='Frecuencia de pago*'
                dataProvider={filteredAndSortedData}
                valueSelect={AutoHN.paymentFrequency}
                field='paymentFrequency'
                onChangeSelect={onChangeCbo}
                placeholder='Selecciona'
            />
                    
            <Modal className="modal" isOpen={propModalSpecial} ariaHideApp={false}>
                <form id='formSpecial' action='' onSubmit={onChangeCob}>
                    <div className="modal-body-info">
                        <div className='center pb-15'>
                            <span className="lbl-encabezado3-autohn">Equipo Especial</span>
                        </div>
                        <div className='display-flex pb-15'>
                            <div className='pr-5 w60'>
                                <Input
                                    id='Observaciones'
                                    label='Nombre del Item'
                                    value={specialteam?.Observaciones}
                                    field='Observaciones'
                                    onChange={changeHandlers}
                                    placeholder="Ingrese la Observación"
                                    isRequired={true}
                                />
                            </div>
                            <div className='pl-10 w40'>
                                <Input
                                    id='Valor'
                                    label='Valor'
                                    value={specialteam?.Valor}
                                    field='Valor'
                                    onChange={changeHandlers}
                                    placeholder="Ingrese el valor"
                                    isRequired={true}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <div className="control-button-autohn pl-14 pr-14 pb-15">
                            <button
                                className="control-button-btn-autohn prev"
                                type="button"
                                onClick={() => setpropModalSpecial(false)}
                            >
                                Regresar
                            </button>
                            <button
                                className="control-button-btn-autohn next"
                                type="submit"
                            >
                                Siguiente
                            </button>
                        </div>
                    </div>
                </form>
            </Modal>
        </>
    );
}

export { Step3 }